// extracted by mini-css-extract-plugin
export var mainContainer = "styles-module--mainContainer--1JPo3";